import { atomWithGlobalStore } from '@highlight/ipc/jotai'
import { ONBOARDING_COMPLETE_FLAG } from '@shared/onboarding/onboarding-flags'
import { useAtomValue } from 'jotai'

const onboardedAtom = atomWithGlobalStore<number>('user', ONBOARDING_COMPLETE_FLAG, 0)

export const useIsOnboarded = () => {
  const isOnboarded = useAtomValue(onboardedAtom)
  return !!isOnboarded
}
